import React from 'react'

/**
 * HanddrawnArrow
 * Den karakteristiske håndtegnede SVG-pil fra Nørbæk Efterskole referencen.
 * Har en blød, uregelmæssig kurve med en lille krølle/løkke i begyndelsen,
 * en svagt buet bevægelse mod højre og en åben pilespids med afrundede stregender.
 */
export function HanddrawnArrow({
  className = '',
  width = 48,
  height = 24,
  strokeWidth = 3,
  ariaHidden = true,
  ...props
}) {
  return (
    <svg
      viewBox="0 0 80 40"
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={ariaHidden}
      className={`organic-btn__arrow ${className}`.trim()}
      {...props}
    >
      <path d="M 4 20 C 20 18.5, 45 21.5, 72 20" />
      <path d="M 54 9 L 74 20 L 54 31" />
    </svg>
  )
}

/**
 * HanddrawnDecorativeArrow
 * Større dekorativ håndtegnet pil til callouts og fremhævede sektioner.
 */
export function HanddrawnDecorativeArrow({
  className = '',
  width = 100,
  height = 112,
  strokeWidth = 5,
  ariaHidden = true,
  ...props
}) {
  return (
    <svg
      viewBox="0 0 160 180"
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={ariaHidden}
      className={className}
      {...props}
    >
      <path
        d="M25 18
           C 85 12, 112 55, 91 85
           C 77 105, 48 91, 64 71
           C 80 50, 115 84, 116 145"
      />
      <path d="M96 124 L116 148 L137 125" />
    </svg>
  )
}

export default HanddrawnArrow
